<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <div style="float: left; position: relative; width: 70%; border-collapse: collapse; text-align: left">
                    <h4 class="m-b-0 text-white">Obras de cliente: {{clienteNombre}}</h4>
                </div>



            </div>
            <!-- padre-->
            <div class="card-body" id="padre">

                <div style="width: 20%; float: right;">
                    <tr style="float: right; position: relative;">
                        <!-- <button type="button" name="actualizar" (click)="actualizar()">Actualizar y Limpiar</button> -->
                        <button type="button" name="respaldo" (click)="printRespaldo()">Respaldo para recolección</button>
                    </tr>
                </div>

                <div *ngFor="let orden of responseMensaje">

                    <!--Div contenedor de tabla y botones-->
                    <div class="areaContratos" style="float: left; position: relative; width: 60%; border-collapse: collapse; text-align: center">
                        <h4> Contrato: {{orden.contrato.noContrato}} </h4>
                        <label> <strong>Obras:</strong> {{orden.descripcion}} </label>
                    </div>
                    <div style="float: left; position: relative; width: 100%; border-collapse: collapse; text-align: center">
                        <tr></tr>
                    </div>
                    <div class="areaTabla" style="float: left; position: relative; width: 60%; border-collapse: collapse;">
                        <table class="table table table-striped table-hover letraImprimir" style="text-align: center;">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th style="text-align: center; font-size: 15px">Código</th>
                                    <th style="text-align: center; font-size: 15px">Descripción</th>
                                    <th style="text-align: center; font-size: 15px">Cantidad</th>
                                    <th style="text-align: center; font-size: 15px">Cantidad faltante</th>
                                    <th style="text-align: center; font-size: 15px">Material que ingresa</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let producto of orden.material">
                                    <td></td>
                                    <td>{{ producto.codigo }}</td>
                                    <td>{{ producto.descripcion }}</td>
                                    <td>{{ producto.cantidad }}</td>
                                    <td>{{ producto.cantidadFaltante }}</td>
                                    <td style="text-align: center">
                                        <input id="producto.codigo" class="form-control input" type="number" name="producto.descripcion" [(ngModel)]="producto.entradas">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!--Botones-->
                    <div style="float: right; position: relative; width: 30%; border-collapse: collapse;">
                        <tr>
                            <button type="button" name="guardar" (click)="guardarEntradas(orden)">Guardar</button>
                        </tr>
                        <br/>
                        <!-- <tr>
                            <button type="button" name="orden.ordenTrabajoId" (click)="print(orden)">Imprimir</button>
                        </tr> -->
                        <br/>
                        <tr>
                            <button type="button" (click)="bitacora(orden)" data-toggle="modal" data-target="#desplegarBitacora">Bitacora</button>
                        </tr>
                    </div>

                    <div style="float: left; position: relative; width: 90%; border-collapse: collapse;">
                        <br/>
                        <hr style="border: .5px solid">
                        <br/>
                    </div>

                </div>

            </div>
            <!-- padre-->
            <!-- ======================================= -->
            <!-- ============ PARA IMPRIMIR ENTRADAS ============ -->
            <!-- ======================================= -->
            <div id="print-section1" style="display:none">

                <!-- Div cabecera-->
                <div style="float: left; position: relative; width: 100%; border: 0.1px solid black; border-collapse: collapse;">
                    <br/>
                    <table class="tablaMedida" style="width: 100%">
                        <tr style="text-align: center">
                            <th rowspan="6" style="text-align: left">
                                <!-- colspan="2" rowspan="4" -->
                                <img src="../../../assets/images/SM8LogoImp.png" alt="105px" width="130px">
                            </th>
                            <th class="letraImprimir"> <strong> Entrada de Material por Folio </strong> </th>
                        </tr>
                        <tr style="text-align: left">
                            <td class="letraImprimir" style="text-align: left">Cliente: {{ cliente }}</td>
                            <td class="letraImprimir" style="text-align: center">No. de Contrato: {{ numeroContrato }} </td>

                        </tr>
                        <tr style="text-align: right">
                            <td></td>
                            <td class="letraImprimir" style="text-align: center">Folio: {{ folio }} </td>
                        </tr>
                        <tr>
                            <td></td>
                        </tr>
                        <tr style="text-align: left">
                            <td colspan="1" class="letraImprimir" style="text-align: left">Almacen: <strong> {{ almacen }} </strong> </td>
                            <td colspan="2" class="letraImprimir" style="text-align: center">Fecha: {{ fechaDia }} </td>
                        </tr>
                    </table>
                    <br/>
                </div>

                <div style="float: left; position: relative; width: 100%; border-collapse: collapse;">
                    <br/>
                    <hr style="border: .5px solid">
                    <br/>
                </div>

                <div style="float: left; position: relative; width: 100%; border-collapse: collapse;">
                    <div>
                        <tr>
                            <td> Fecha de movimientos: {{ fechaMovimiento }} </td>
                        </tr>
                    </div>

                    <div>
                        <br/>
                        <table class="table table table-striped table-hover letraImprimir" style="text-align: center;  border: 0.1px solid black; width: 100%">
                            <thead>
                                <tr>
                                    <th style="text-align: center; font-size: 15px">Código</th>
                                    <th style="text-align: center; font-size: 15px">Descripción</th>
                                    <th style="text-align: center; font-size: 15px">Cantidad por entrada</th>
                            </thead>
                            <tbody>
                                <tr *ngFor="let producto of productoBitacora">
                                    <td> {{producto.producto.codigo}} </td>
                                    <td style="text-align: left"> {{producto.producto.descripcion}} </td>
                                    <td> {{producto.cantidad}} </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                    <!-- Div Contenedor de firmas-->
                    <div style="float: left; position: relative; width: 100%;">
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <table class="letraImprimir" style="width: 100%">
                            <tr>
                                <th colspan="3" style="text-align: center">____________________________</th>
                                <th colspan="3" style="text-align: center">____________________________</th>
                            </tr>
                            <tr>
                                <th class="letraImprimir" colspan="3" style="text-align: center">ALMACENISTA </th>
                                <th class="letraImprimir" colspan="3" style="text-align: center">FIRMA DE CONFORMIDAD </th>
                            </tr>
                        </table>

                    </div>
                    <!-- Div Contenedor de firmas-->

                </div>

            </div>


            <!-- ======================================= -->
            <!-- ============ PARA IMPRIMIR RESPALDO ============ -->
            <!-- ======================================= -->
            <div id="print-section" style="display:none">

                <!-- Div cabecera-->
                <div style="float: left; position: relative; width: 100%; border: 0.1px solid black; border-collapse: collapse;">
                    <br/>
                    <table class="tablaMedida" style="width: 100%">
                        <tr style="text-align: center">
                            <th rowspan="6" style="text-align: left">
                                <!-- colspan="2" rowspan="4" -->
                                <img src="../../../assets/images/SM8LogoImp.png" alt="105px" width="130px">
                            </th>
                            <th class="letraImprimir"> <strong> Entrada de Material </strong> </th>
                        </tr>
                        <tr style="text-align: left">
                            <td class="letraImprimir" style="text-align: left">Cliente: {{ cliente }}</td>
                            <td colspan="1" class="letraImprimir" style="text-align: center">Almacen: <strong> {{ almacen }} </strong> </td>
                        </tr>
                        <tr style="text-align: right">
                            <td></td>
                            <td colspan="2" class="letraImprimir" style="text-align: center">No. de Contrato: {{ numeroContrato }} </td>
                        </tr>
                        <tr style="text-align: left">
                            <td class="letraImprimir" style="text-align: left">Direccion de la Obra: {{ direccionObra }}</td>
                            <td colspan="2" class="letraImprimir" style="text-align: center">Fecha: {{ fechaDia }} </td>
                        </tr>
                    </table>
                    <br/>
                </div>
                <!-- Div cabecera-->

                <!-- Div Contenedor de Tabalas material-->
                <!-- SM-8-->
                <div style="background-color: navajowhite ">
                    <div style="float: left; position: relative; width: 36%; border: 0.1px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;">SM-8</caption>
                            <thead>
                                <tr></tr>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                                <tr></tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 9">
                                        <td> {{ producto.codigo }} </td>
                                        <td> {{producto.descrpcion}} </td>
                                        <td *ngIf="producto.cantidad === 0; else traer1">_______</td>
                                        <ng-template #traer1>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--TUBERIA DIAM 48 MM-->
                    <div style="float: left; position: relative; width: 35%; border: 0.1px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;">TUBERIA DIAM 48 MM</caption>
                            <thead>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                <div class=letraImprimir *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 1">
                                        <td> {{ producto.codigo }} </td>
                                        <td> {{producto.descrpcion}} </td>
                                        <td *ngIf="producto.cantidad === 0; else traer2">_______</td>
                                        <ng-template #traer2>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--CRUCETAS-->
                    <div style="float: left; position: relative; width: 28%; border: 0.1px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;">CRUCETAS</caption>
                            <thead>
                                <tr>
                                    <th style="text-align: center; font-size: 8px;">Código</th>
                                    <th style="text-align: center; font-size: 8px;">Descripción</th>
                                    <th style="text-align: center; font-size: 8px;">Cantidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 6">
                                        <td> {{ producto.codigo }} </td>
                                        <td> {{producto.descrpcion}} </td>
                                        <td *ngIf="producto.cantidad === 0; else traer3">_______</td>
                                        <ng-template #traer3>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--VIGADALES Y DUELAS-->
                    <div style="float: left; position: relative; width: 28%; border: 0.1px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;">VIGADALES Y DUELAS</caption>
                            <thead>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                                <tr></tr>
                                <tr></tr>
                                <tr></tr>
                                <tr></tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 10">
                                        <td> {{ producto.codigo }} </td>
                                        <td> {{producto.descrpcion}} </td>
                                        <td *ngIf="producto.cantidad === 0; else traer4">_______</td>
                                        <ng-template #traer4>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--ACCESORIOS-->
                    <div style="float: left; position: relative; width: 35%; border: 0.1px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;">ACCESORIOS</caption>
                            <thead>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 8">
                                        <td style="text-align: center"> {{ producto.codigo }} </td>
                                        <td style="text-align: center"> {{producto.descrpcion}} </td>
                                        <td style="text-align: center" *ngIf="producto.cantidad === 0; else traer5">_______</td>
                                        <ng-template #traer5>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--VALLAS-->
                    <div style="float: left; position: relative; width: 28%; border: 0.1px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;">VALLAS</caption>
                            <thead>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                <div style="width: 100%" *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 15">
                                        <td style="text-align: center"> {{ producto.codigo }} </td>
                                        <td style="text-align: center"> {{producto.descrpcion}} </td>
                                        <td style="text-align: center" *ngIf="producto.cantidad === 0; else traer6">_______</td>
                                        <ng-template #traer6>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--ESCALERA-->
                    <div style="float: left; position: relative; width: 35%; border: 0.1px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;">ESCALERA</caption>
                            <thead>
                                <tr></tr>
                                <tr></tr>
                                <tr></tr>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                                <tr></tr>
                                <tr></tr>
                                <tr></tr>
                                <tr></tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 14">
                                        <td style="text-align: center"> {{ producto.codigo }} </td>
                                        <td style="text-align: center"> {{producto.descrpcion}} </td>
                                        <td style="text-align: center" *ngIf="producto.cantidad === 0; else traer7">_______</td>
                                        <ng-template #traer7>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--RUEDAS-->
                    <div style="float: left; position: relative; width: 28%; border: 0.1px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;">RUEDAS</caption>
                            <thead>
                                <tr></tr>
                                <tr></tr>
                                <tr></tr>
                                <tr></tr>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                                <tr></tr>
                                <tr></tr>
                                <tr></tr>
                                <tr></tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 7">
                                        <td style="text-align: center"> {{ producto.codigo }} </td>
                                        <td style="text-align: center"> {{producto.descrpcion}} </td>
                                        <td style="text-align: center" *ngIf="producto.cantidad === 0; else traer8">_______</td>
                                        <ng-template #traer8>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--HAMACAS-->
                    <div style="float: left; position: relative; width: 35%; border: 0.1px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;">HAMACAS</caption>
                            <thead>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                                <tr></tr>
                                <tr></tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 4">
                                        <td> {{ producto.codigo }} </td>
                                        <td> {{producto.descrpcion}} </td>
                                        <td *ngIf="producto.cantidad === 0; else traer9">_______</td>
                                        <ng-template #traer9>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--BASES-->
                    <div style="float: left; position: relative; width: 28%; border: 0.1px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;">BASES</caption>
                            <thead>
                                <tr></tr>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                                <tr></tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 3">
                                        <td> {{ producto.codigo }} </td>
                                        <td> {{producto.descrpcion}} </td>
                                        <td *ngIf="producto.cantidad === 0; else obtener10">_______</td>
                                        <ng-template #obtener10>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--JUNTAS-->
                    <div style="float: left; position: relative; width: 36%; border: 0.5px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;">JUNTAS</caption>
                            <!--style="position: relative; float: left"-->
                            <thead>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                                <tr></tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 2">
                                        <td> {{ producto.codigo }} </td>
                                        <td> {{producto.descrpcion}} </td>
                                        <td *ngIf="producto.cantidad === 0; else traer11">_______</td>
                                        <ng-template #traer11>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                        <br/>
                    </div>

                    <!--TARIMAS-->
                    <div style="float: left; position: relative; width: 35%; border: 0.5px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;">TARIMAS</caption>
                            <thead>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                                <tr></tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 13">
                                        <td> {{ producto.codigo }} </td>
                                        <td> {{producto.descrpcion}} </td>
                                        <td *ngIf="producto.cantidad === 0; else traer12">_______</td>
                                        <ng-template #traer12>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                        <br/>
                        <br/>
                    </div>

                    <!--MARCOS-->
                    <div style="float: left; position: relative; width: 28%; border: 0.5px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;">MARCOS</caption>
                            <thead>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 5">
                                        <td style="text-align: center"> {{ producto.codigo }} </td>
                                        <td style="text-align: center"> {{producto.descrpcion}} </td>
                                        <td style="text-align: center" *ngIf="producto.cantidad === 0; else traer13">_______</td>
                                        <ng-template #traer13>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--TEMPLETE-->
                    <div style="float: left; position: relative; width: 36%; border: 0.5px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;">TEMPLETE</caption>
                            <thead>
                                <tr></tr>
                                <tr></tr>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                                <tr></tr>
                                <tr></tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 16">
                                        <td> {{ producto.codigo }} </td>
                                        <td> {{producto.descrpcion}} </td>
                                        <td *ngIf="producto.cantidad === 0; else traer14">_______</td>
                                        <ng-template #traer14>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--MATERIAL DE MADERA-->
                    <div style="float: left; position: relative; width: 35%; border: 0.5px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;">MATERIAL DE MADERA</caption>
                            <thead>
                                <tr></tr>
                                <tr></tr>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                                <tr></tr>
                                <tr></tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 18">
                                        <td style="text-align: center"> {{ producto.codigo }} </td>
                                        <td style="text-align: center"> {{producto.descrpcion}} </td>
                                        <td style="text-align: center" *ngIf="producto.cantidad === 0; else traer15">_______</td>
                                        <ng-template #traer15>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--ESCALONES-->
                    <div style="float: left; position: relative; width: 28%; border: 0.5px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;"> ESCALONES</caption>
                            <thead>
                                <tr></tr>
                                <tr></tr>
                                <tr></tr>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                                <tr></tr>
                                <tr></tr>
                                <tr></tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 17">
                                        <td> {{ producto.codigo }} </td>
                                        <td> {{producto.descrpcion}} </td>
                                        <td *ngIf="producto.cantidad === 0; else traer16">_______</td>
                                        <ng-template #traer16>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--Consumibles-->
                    <div style="float: left; position: relative; width: 36%; border: 0.5px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;"> CONSUMIBLES </caption>
                            <thead>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 23">
                                        <td style="text-align: center"> {{ producto.codigo }} </td>
                                        <td style="text-align: center"> {{producto.descrpcion}} </td>
                                        <td style="text-align: center" *ngIf="producto.cantidad === 0; else traer23">_______</td>
                                        <ng-template #traer23>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--Puntales-->
                    <div style="float: left; position: relative; width: 35%; border: 0.5px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;"> PUNTALES</caption>
                            <thead>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                                <tr></tr>
                                <tr></tr>
                                <tr></tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 11">
                                        <td> {{ producto.codigo }} </td>
                                        <td> {{producto.descrpcion}} </td>
                                        <td *ngIf="producto.cantidad === 0; else traer17">_______</td>
                                        <ng-template #traer17>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--DUELAS-->
                    <div style="float: left; position: relative; width: 28%; border: 0.5px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;"> DUELAS </caption>
                            <thead>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 22">
                                        <td style="text-align: center"> {{ producto.codigo }} </td>
                                        <td style="text-align: center"> {{producto.descrpcion}} </td>
                                        <td style="text-align: center" *ngIf="producto.cantidad === 0; else traer22">_______</td>
                                        <ng-template #traer22>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--Geoplak-->
                    <div style="float: left; position: relative; width: 28%; border: 0.5px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;"> GEOPLAK </caption>
                            <thead>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 21">
                                        <td style="text-align: center"> {{ producto.codigo }} </td>
                                        <td style="text-align: center"> {{producto.descrpcion}} </td>
                                        <td style="text-align: center" *ngIf="producto.cantidad === 0; else traer21">_______</td>
                                        <ng-template #traer21>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--Vigas extencibles-->
                    <div style="float: left; position: relative; width: 35%; border: 0.5px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;"> VIGAS EXTENCIBLES</caption>
                            <thead>
                                <tr></tr>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 12">
                                        <td style="text-align: center"> {{ producto.codigo }} </td>
                                        <td style="text-align: center"> {{producto.descrpcion}} </td>
                                        <td style="text-align: center" *ngIf="producto.cantidad === 0; else traer18">_______</td>
                                        <ng-template #traer18>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>

                    <!--Vigas IPR-->
                    <div style="float: left; position: relative; width: 28%; border: 0.5px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;"> VIGAS IPR </caption>
                            <thead>
                                <tr></tr>
                                <tr></tr>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                                <tr></tr>
                                <tr></tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 20">
                                        <td style="text-align: center"> {{ producto.codigo }} </td>
                                        <td style="text-align: center"> {{producto.descrpcion}} </td>
                                        <td style="text-align: center" *ngIf="producto.cantidad === 0; else traer20">_______</td>
                                        <ng-template #traer20>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                        <br/>
                    </div>

                    <!--Vigas H20-->
                    <div style="float: left; position: relative; width: 36%; border: 0.5px solid black; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100%">
                            <caption style="border: 0.1px solid black; border-collapse: collapse;"> VIGAS H20 </caption>
                            <thead>
                                <tr>
                                    <th style="text-align: center; font-size: 8px">Código</th>
                                    <th style="text-align: center; font-size: 8px">Descripción</th>
                                    <th style="text-align: center; font-size: 8px">Cantidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let producto of arrayMaterial">
                                    <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 19">
                                        <td style="text-align: center"> {{ producto.codigo }} </td>
                                        <td style="text-align: center"> {{producto.descrpcion}} </td>
                                        <td style="text-align: center" *ngIf="producto.cantidad === 0; else traer19">_______</td>
                                        <ng-template #traer19>
                                            <td style="text-align: center">{{producto.cantidad}}</td>
                                        </ng-template>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>





                </div>
                <!-- Div Contenedor de Tabalas material-->

                <div style="float: left; position: relative; width: 100%;">
                    <br/>
                </div>

                <!-- Div Contenedor de notas y firmas-->

                <div style="background-color: navajowhite ">

                    <!-- Div Contenedor de notas-->
                    <div style="float: left; position: relative; width: 70%; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 95% ;border: 0.1px solid black; border-collapse: collapse;">
                            <th>NOTAS</th>
                            <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                                <th></th>
                            </tr>
                            <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                                <th></th>
                            </tr>
                            <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                                <th></th>
                            </tr>
                            <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                                <th></th>
                            </tr>
                            <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                                <th></th>
                            </tr>
                            <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                                <th></th>
                            </tr>
                            <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                                <th></th>
                            </tr>
                            <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                                <th></th>
                            </tr>
                        </table>
                    </div>

                    <div style="float: left; position: relative; width: 25%; border-collapse: collapse;">
                        <table class="letraImprimir" style="width: 100% ;border: 0.1px solid black; border-collapse: collapse;">
                            <th>HERRAMIENTA</th>
                            <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                                <th></th>
                            </tr>
                            <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                                <th></th>
                            </tr>
                            <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                                <th></th>
                            </tr>
                            <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                                <th></th>
                            </tr>
                            <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                                <th></th>
                            </tr>
                            <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                                <th></th>
                            </tr>
                            <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                                <th></th>
                            </tr>
                            <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                                <th></th>
                            </tr>
                        </table>
                    </div>
                    <!-- Div Contenedor de notas-->

                    <div style="float: left; position: relative; width: 100%;">
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                    </div>

                    <!-- Div Contenedor de firmas-->
                    <div style="float: left; position: relative; width: 100%;">
                        <table class="letraImprimir" style="width: 100%">
                            <tr>
                                <th colspan="3" style="text-align: center">____________________________</th>
                                <th colspan="3" style="text-align: center">____________________________</th>
                                <th colspan="3" style="text-align: center">____________________________</th>
                            </tr>
                            <tr>
                                <th class="letraImprimir" colspan="3" style="text-align: center">ENTREGO </th>
                                <th class="letraImprimir" colspan="3" style="text-align: center">TRANSPORTISTA </th>
                                <th class="letraImprimir" colspan="3" style="text-align: center">FIRMA DE CONFORMIDAD </th>
                            </tr>
                        </table>

                    </div>
                    <!-- Div Contenedor de firmas-->

                </div>
            </div>
        </div>

        <!-- ================================== -->
            <!-- ===== Modal Bitacora ===== -->
            <!-- ================================== -->
            <div class="modal fade" id="desplegarBitacora" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="float float-right">Bitacora de movimientos</h4>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                            </div>
    
                            <div class="modal-body">
                                <FORM class="form-horizontal form-material">
                                    <div class="col-sm-12 float float-right table-responsive">
    
                                        <div>
                                            <div class="control-label text-left col-sm-6">
                                                <label>Seleccione el folio a consultar</label>
                                                <br/>
                                                <form>
                                                    <br/>
                                                    <tr>
                                                        <td>Folio del movimiento:</td>
                                                        <select class="form-control variosSelect" [(ngModel)]="folio" name="folio">
                                                                <option *ngFor="let fselect of arrayFolios" [value]="fselect.folio">{{ fselect.folio }}</option>
                                                            </select>
                                                        <button type="button" (click)="mostrarBitacora()" name="buscar">Buscar</button>
                                                    </tr>
    
                                                </form>
    
                                                <!-- <label>Fecha de movimiento</label>
                                                <form #myForm="ngForm" novalidate class="col-md-6">
                                                    <my-date-picker id="myCalendario" date-format="yyyy-MM-dd" [options]="myDatePickerOptions" name="fechaIn" [(ngModel)]="fechaObra" required></my-date-picker>
                                                     [(ngModel)]="fechaDeInicio" 
                                                    <button type="button" name="buscar" (click)="bitacora(orden)">Buscar</button>
                                                </form> -->
                                            </div>
                                        </div>
    
                                        <div id="tablaDeMaterial" style="display: none">
    
                                            <div>
                                                <tr>
                                                    <td>Fecha: {{ fechaMovimiento }} </td>
                                                </tr>
                                                <tr>
                                                    <td>Contrato: {{ noContrato }} </td>
                                                </tr>
                                            </div>
    
                                            <table class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
    
                                                <thead>
                                                    <tr>
                                                        <td><strong>Codigo</strong></td>
                                                        <td><strong>Descripción</strong></td>
                                                        <td><strong>Cantidad que ingreso</strong></td>
                                                    </tr>
                                                </thead>
    
                                                <tbody>
                                                    <tr *ngFor="let producto of productoBitacora">
                                                        <td> {{producto.producto.codigo}} </td>
                                                        <td> {{producto.producto.descripcion}} </td>
                                                        <td> {{producto.cantidad}} </td>
                                                    </tr>
                                                </tbody>
    
                                            </table>
                                        </div>
    
                                    </div>
                                </FORM>
                            </div>
                            <div class="modal-footer">
                                <button type="button" (click)="print()" data-dismiss="modal"><i class="mdi mdi-printer"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
    
                <!-- ================================== -->
                <!-- ===== Modal Bitacora ===== -->
                <!-- ================================== -->


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/entradas-material/entradas-material.component.html